module.exports = __webpack_public_path__ + "static/img/14010210.2a646831.png";